import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { GetDataService } from '../../shared/services/get-data.service';
import { RequestFormService } from '../../shared/services/request-form.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';

@Component({
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  styleUrls: ['./bot.component.scss'],
})
export class BotComponent implements OnInit {
  public email = '';
  public requestNumber = '';
  constructor(
    private getDataService: GetDataService,
    private requestFormService: RequestFormService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRouter: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRouter.queryParams.subscribe((params) => {
      this.requestNumber = params['requestNumber'];
      this.email = params['mail'];
    });

    this.getDataService
      .getSolicitudData(this.email, this.requestNumber)
      .subscribe({
        next: (resp) => {
          const dataForm = {
            email: this.email,
            requestNumber: this.requestNumber,
          };
          sessionStorage.setItem(
            'experienceType',
            resp.general.experienceTypeCode
          );
          sessionStorage.setItem('creditType', resp.creditType.toString());
          sessionStorage.setItem('email', resp.email);
          sessionStorage.setItem('requestNumber', resp.requestNumber);
          sessionStorage.setItem('stepNumber', '4');
          this.requestFormService.setDataForm(dataForm);
          this.requestFormService.setUpdateForm(resp);
          this.router.navigate(['/solicitud']);
        },
        error: () => {
          this.openRequestInformationDialog();
        },
      });
  }

  openRequestInformationDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = '90%';
    dialogConfig.data = {
      title: 'Información de busqueda',
      question: `Su solicitud no ha sido localizada, favor de verificar sus datos.`,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['/busqueda']);
        sessionStorage.clear();
      });
  }
}
